jQuery(document).ready(function($) {
    $(".dnCatchmentAreaMap").each(function () {

        var mapContainer = $(this),
            centerLat = parseFloat(mapContainer.attr('data-centerLat')),
            centerLong = parseFloat(mapContainer.attr('data-centerLong')),
            dataUrl = mapContainer.attr('data-dataUrl'),
            map,
            cachedGeoJson;


                map = new google.maps.Map(mapContainer[0], {
                    zoom: 8,
                    center: {lat: centerLat, lng: centerLong},
                    scrollwheel: false
                });

            // Load GeoJSON.
            /** @var {Promise} promise */
            var promise = $.getJSON(dataUrl);
            promise.then(function (data) {
                cachedGeoJson = data;

                var markers = [];
                $.each(cachedGeoJson.features, function(i, item){
                    var item = (item.geometry.coordinates);
                    var latLng = new google.maps.LatLng(item[1], item[0]);
                    var marker = new google.maps.Marker({position: latLng});
                    markers.push(marker);
                });

                var options = {styles: [
                    {
                        textColor: 'black',
                        url: '/js/rd/lib/markercluster/m1.png',
                        height: 53,
                        width: 53
                    },
                    {
                        textColor: 'black',
                        url: '/js/rd/lib/markercluster/m2.png',
                        height: 56,
                        width: 56
                    },
                    {
                        textColor: 'black',
                        url: '/js/rd/lib/markercluster/m3.png',
                        height: 66,
                        width: 66
                    },
                    {
                        textColor: 'black',
                        url: '/js/rd/lib/markercluster/m4.png',
                        height: 78,
                        width: 78
                    },
                    {
                        textColor: 'black',
                        url: '/js/rd/lib/markercluster/m5.png',
                        height: 90,
                        width: 90
                    }
                ]};

                var markerCluster = new MarkerClusterer(map, markers, options);
            }, function (error) {
                console.log(error);
            })

    });
});
